export default __webpack_public_path__ + "static/media/JoeAbah.33b32e10.svg";